import React, { useState } from 'react';
import { useApiClient } from '../api/client';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../toast/ToastProvider';
import { PageHeader, PageShell } from '../components/ui';
import { useI18n } from '../i18n/I18nProvider';

export const CreateCommunityPage: React.FC = () => {
  const { request } = useApiClient();
  const navigate = useNavigate();
  const { showError, showSuccess } = useToast();
  const { t } = useI18n();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [type, setType] = useState('COMPANY');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await request<{ id: string }>('/communities', {
        method: 'POST',
        body: JSON.stringify({ name, description, type }),
      });
      showSuccess(t('communities.created'));
      navigate('/communities');
    } catch (err) {
      const msg = (err as any)?.message || 'Failed to create community';
      setError(msg);
      showError(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <PageShell>
      <PageHeader
        title={t('communities.createTitle')}
        description={t('communities.createDescription')}
        actions={<button className="btn btn-neutral" onClick={() => navigate('/communities')}>{t('communities.cancel')}</button>}
      />
      <form onSubmit={submit} className="admin-panel max-w-3xl p-5 sm:p-6">
        {error && <div className="mb-5 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700" role="alert">{error}</div>}
        <div className="grid gap-5">
          <div>
            <label className="admin-form-label" htmlFor="new-community-name">{t('communities.name')}</label>
            <input id="new-community-name" className="form-control mt-1 w-full" value={name} onChange={(event) => setName(event.target.value)} required placeholder="mobie Berlin" />
          </div>
          <div>
            <label className="admin-form-label" htmlFor="new-community-description">{t('communities.descriptionField')}</label>
            <textarea id="new-community-description" className="form-control mt-1 w-full" rows={4} value={description} onChange={(event) => setDescription(event.target.value)} placeholder={t('communities.descriptionPlaceholder')} />
          </div>
          <div>
            <label className="admin-form-label" htmlFor="new-community-type">{t('communities.type')}</label>
            <select id="new-community-type" className="form-control mt-1 w-full sm:max-w-md" value={type} onChange={(event) => setType(event.target.value)}>
              <option value="COMPANY">{t('communities.company')}</option>
              <option value="MUNICIPALITY">{t('communities.municipality')}</option>
            </select>
          </div>
          <div className="flex flex-wrap justify-end gap-2 border-t border-slate-200 pt-4">
            <button type="button" className="btn btn-neutral" onClick={() => navigate('/communities')}>{t('communities.cancel')}</button>
            <button type="submit" disabled={loading || !name.trim()} className="btn btn-primary">
              {loading ? t('communities.creating') : t('communities.createAction')}
            </button>
          </div>
        </div>
      </form>
    </PageShell>
  );
};
